import React from 'react'
import LayoutStack from './layout-stack';
import LayoutSlider from './layout-slider';
import LayoutAccordion from './layout-accordion';

import "./index.css"
import { Container } from '../Container';

const Gallery = ({ galleryData, isFluid=true }) => {
    let layoutOptions = galleryData.galleryLayoutOptions

    return (
        <div className={`component-gallery`}>
            <div className={isFluid ? '':'container-custom'}>
                <div className='gallery'>
                    {galleryData.galleryNameVisibility && <Container><h3 className='mt-0'>{galleryData.galleryName}</h3></Container>}
                    {layoutOptions === 'Default: Stack' 
                      ? <Container><LayoutStack data={galleryData} /></Container>
                      : layoutOptions === 'Slider'
                      ? <LayoutSlider data={galleryData} />
                      : <LayoutAccordion data={galleryData} />
                    }
                </div>
            </div>
        </div>
    )
}

export default Gallery